import * as React from 'react'
import { IOWidget, Updater, fromJSX } from 'widgets-for-react'
import { GridHighlightBlock } from '../../publicSite/blocks/custom_blocks/widgets/gridHighlightBlock'
import { CMSState } from '../../publicSite/drupalPage/state'
import { BlockData } from './types.gen'
import { CtaBlock } from './widgets/ctaBlock.gen'
import { DownloadBlock } from './widgets/downloadBlock.gen'
import { ExpandBlock } from './widgets/expandBlock.gen'
import { IframeBlock } from './widgets/iframeBlock.gen'
import { ImageGalleryBlock } from './widgets/imageGalleryBlock.gen'
import { LinkBlock } from './widgets/linkBlock.gen'
import { LinkGridBlock } from './widgets/linkGridBlock.gen'
import { MediaBlock } from './widgets/mediaBlock.gen'
import { MediaBlockNested } from './widgets/mediaBlockNested.gen'
import { QuoteBlock } from './widgets/quoteBlock.gen'
import { QuoteBlockNested } from './widgets/quoteBlockNested.gen'
import { TextBlockWidget } from './widgets/textBlock.gen'
import { TextBlockNested } from './widgets/textBlockNested.gen'
import { TextImageBlock } from './widgets/textImageBlock.gen'
import { TextReadMoreBlock } from './widgets/textReadMoreBlock.gen'

const blockRenderer = {
  textImageBlock: TextImageBlock,
  expandBlock: ExpandBlock,
  mediaBlock: MediaBlock,
  mediaBlockNested: MediaBlockNested,
  linkGridBlock: LinkGridBlock,
  linkBlock: LinkBlock,
  downloadBlock: DownloadBlock,
  ctaBlock: CtaBlock,
  textBlock: TextBlockWidget,
  textBlockNested: TextBlockNested,
  textReadMoreBlock: TextReadMoreBlock,
  quoteBlock: QuoteBlock,
  quoteBlockNested: QuoteBlockNested,
  imageGalleryBlock: ImageGalleryBlock,
  iframeBlock: IframeBlock,
  gridHighlightBlock: GridHighlightBlock
}

export const renderBlock =
  (block: BlockData, key?: string): IOWidget<CMSState, Updater<CMSState>> =>
  (s0) =>
    block.kind === 'textImageBlock'
      ? blockRenderer.textImageBlock(block.value[0], { style: block.value[1], key })(s0)
      : block.kind === 'imageGalleryBlock'
      ? blockRenderer.imageGalleryBlock(block.value[0], { style: block.value[1], key })(s0)
      : block.kind === 'textBlock'
      ? blockRenderer.textBlock(block.value[0], { style: block.value[1], key })(s0)
      : block.kind === 'textBlockNested'
      ? blockRenderer.textBlockNested(block.value[0], { style: block.value[1], key })(s0)
      : block.kind === 'textReadMoreBlock'
      ? blockRenderer.textReadMoreBlock(block.value[0], { style: block.value[1], key })(s0)
      : block.kind === 'ctaBlock'
      ? blockRenderer.ctaBlock(block.value[0], { style: block.value[1], key })(s0)
      : block.kind === 'downloadBlock'
      ? blockRenderer.downloadBlock(block.value[0], { key, style: block.value[1] })(s0)
      : block.kind === 'linkBlock'
      ? blockRenderer.linkBlock(block.value[0], { style: block.value[1], key })(s0)
      : block.kind === 'linkGridBlock'
      ? blockRenderer.linkGridBlock(block.value[0], { style: block.value[1], key })(s0)
      : block.kind === 'mediaBlock'
      ? blockRenderer.mediaBlock(block.value[0], { style: block.value[1], key })(s0)
      : block.kind === 'mediaBlockNested'
      ? blockRenderer.mediaBlockNested(block.value[0], { style: block.value[1], key })(s0)
      : block.kind === 'expandBlock'
      ? blockRenderer.expandBlock(block.value[0], { style: block.value[1], key })(s0)
      : block.kind === 'quoteBlock'
      ? blockRenderer.quoteBlock(block.value[0], { style: block.value[1], key })(s0)
      : block.kind === 'quoteBlockNested'
      ? blockRenderer.quoteBlockNested(block.value[0], { style: block.value[1], key })(s0)
      : block.kind === 'iframeBlock'
      ? blockRenderer.iframeBlock(block.value[0], { style: block.value[1], key })(s0)
      : block.kind === 'gridHighlightBlock'
      ? blockRenderer.gridHighlightBlock(block.value[0], { style: block.value[1], key })(s0)
      : fromJSX(() => <div key={key}>Block not found</div>)
